import { useState, useEffect } from "react";
import { LessonPlanList } from "./components/LessonplanLists";
import { WorksheetList } from "./components/WorksheetLists";

const PRIMARY = "#705ed4";

export function Report({
  lessonPlanList,
  worksheetList,
  onLessonPlanPageChange,
  onWorksheetPageChange,
}) {
  const [activeTab, setActiveTab] = useState("lesson-plans");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    container: {
      display: isDesktop ? "flex" : "block",
      width: "100%",
    },

    tabsWrapper: {
      display: "flex",
      flexDirection: isDesktop ? "column" : "row",
      borderRight: isDesktop ? "1px solid #eee" : "none",
      borderBottom: !isDesktop ? "1px solid #eee" : "none",
      minWidth: isDesktop ? "180px" : "100%",
    },

    tab: (isActive) => ({
      padding: isDesktop ? "10px 12px" : "8px 10px",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "13px",
      color: isActive ? PRIMARY : "#555",
      background: isActive ? "rgba(112,94,212,0.08)" : "transparent",
      borderLeft: isDesktop
        ? isActive
          ? `3px solid ${PRIMARY}`
          : "3px solid transparent"
        : "none",
      borderBottom: !isDesktop
        ? isActive
          ? `2px solid ${PRIMARY}`
          : "2px solid transparent"
        : "none",
      transition: "all 0.2s ease",
    }),

    content: {
      flex: 1,
      padding: isDesktop ? "0 16px" : "12px 0",
    },

    hidden: { display: "none" },
    visible: { display: "block" },
  };

  return (
    <div style={styles.container}>
      {/* Tabs */}
      <div style={styles.tabsWrapper}>
        <div
          style={styles.tab(activeTab === "lesson-plans")}
          onClick={() => setActiveTab("lesson-plans")}
        >
          Lesson Plans
        </div>

        <div
          style={styles.tab(activeTab === "worksheets")}
          onClick={() => setActiveTab("worksheets")}
        >
          Assessments & Worksheets
        </div>
      </div>

      {/* Content */}
      <div style={styles.content}>
        <div
          style={
            activeTab === "lesson-plans"
              ? styles.visible
              : styles.hidden
          }
        >
          <LessonPlanList
            {...lessonPlanList}
            onPageChange={onLessonPlanPageChange}
          />
        </div>

        <div
          style={
            activeTab === "worksheets"
              ? styles.visible
              : styles.hidden
          }
        >
          <WorksheetList
            {...worksheetList}
            onPageChange={onWorksheetPageChange}
          />
        </div>
      </div>
    </div>
  );
}